// extracted by mini-css-extract-plugin
module.exports = {"tag":"DeskBookingForm_tag__351am","selected":"DeskBookingForm_selected__2x4eY"};